// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"446045cb","18":"b1b0da52","117":"356e17df","161":"86bbd646","209":"e1f55257","248":"2fb9d2e5","478":"bab6ea18","625":"ade83638","745":"b5c83463","922":"a9748d02","964":"66795340"}[chunkId] + ".chunk.js";
};